import { z } from 'zod';

export const registerSchema = z.object({
  email: z.string().email('Podaj prawidłowy adres email'),
  password: z
    .string()
    .min(8, 'Hasło musi mieć co najmniej 8 znaków')
    .max(128, 'Hasło może mieć maksymalnie 128 znaków'),
  name: z.string().min(1, 'Podaj imię').max(100).optional(),
});

export const loginSchema = z.object({
  email: z.string().email('Podaj prawidłowy adres email'),
  password: z.string().min(1, 'Podaj hasło'),
});

export const refreshSchema = z.object({
  refreshToken: z.string().min(1, 'Podaj refresh token'),
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type RefreshInput = z.infer<typeof refreshSchema>;
